import React from 'react';
import { BsGeoAlt, BsGeo, BsPinMap, BsMap, BsGlobeAsiaAustralia } from "react-icons/bs";

const LocationMap = ({...props}) => {
    const addressDetail = props.addressData;

    return (
        <div className='flex flex-col py-4 px-4 md:px-7 bg-white box-shadow rounded-xl'>
            <h2 className='text-xl leading-8 font-bold uppercase font-montserrat pb-2 mb-4 text-gray-900 text-center border-b border-gray-200 border-solid'>Address</h2>
            {/* <div className='flex flex-col gap-6'> */}
            <div className='grid grid-cols-1 md:grid-cols-[1fr_1fr] gap-6'>
                <div className='flex flex-col gap-2'>
                    <div className='flex flex-row items-start space-x-2'>
                        <span><BsGeoAlt className='text-base mt-1' /></span>
                        <span className='font-semibold whitespace-nowrap'>Address :</span>
                        <span>{addressDetail.address}</span>
                    </div>
                    {/* {addressDetail.landmark === '' ? '' : 
                    <div className='flex flex-row items-start space-x-2'>
                        <span><BsGeo className='text-base mt-1' /></span>
                        <span className='font-semibold whitespace-nowrap'>Landmark :</span>
                        <span>{addressDetail.landmark}</span>
                    </div>
                    } */}
                    <div className='flex flex-row items-start space-x-2'>
                        <span><BsPinMap className='text-base mt-1' /></span>
                        <span className='font-semibold whitespace-nowrap'>City :</span>
                        <span>{addressDetail.city}</span>
                    </div>
                    <div className='flex flex-row items-start space-x-2'>
                        <span><BsMap className='text-base mt-1' /></span>
                        <span className='font-semibold whitespace-nowrap'>State :</span>
                        <span>{addressDetail.state}</span>
                    </div>
                    <div className='flex flex-row items-start space-x-2'>
                        <span><BsGlobeAsiaAustralia className='text-base mt-1' /></span>
                        <span className='font-semibold whitespace-nowrap'>Country :</span>
                        <span>{addressDetail.country}</span>
                    </div>
                </div>
                <div className='flex border border-solid border-gray-200'><div className='prose prose-sm w-full' dangerouslySetInnerHTML={{ __html: props.locationMap }}></div></div>
            </div>
        </div>
    );
}

export default LocationMap;
